module.exports = __webpack_public_path__ + "static/media/rec.32779635.jpg";